import { clsx } from 'clsx'

import { Button, Flex, Text, Tooltip } from '@buffer-mono/popcorn'

import styles from './ReplyFormFooter.module.css'

export const MAX_CHARS = 500

type ReplyFormFooterProps = {
  currentCharsCount: number
  disabled: boolean
  label?: string
  className?: string
}

export const ReplyFormFooter = ({
  currentCharsCount,
  disabled,
  label = 'Reply',
  className,
}: ReplyFormFooterProps): JSX.Element => {
  return (
    <Flex gap="sm" className={clsx(styles.replyFooter, className)}>
      <Text size="sm" color="subtle">
        {currentCharsCount}/{MAX_CHARS}
      </Text>
      <Tooltip content="Submit reply" shortcut={'mod+Enter'} delay={800}>
        <Button
          variant="primary"
          size="medium"
          type="submit"
          disabled={disabled}
          className={styles.submitButton}
        >
          {label}
        </Button>
      </Tooltip>
    </Flex>
  )
}
